import { DispatcherEvent } from './DispatcherEvent.js';
export class Dispatcher {
    constructor() {
        this.events = {};
    }
    dispatch(eventName, data = {}) {
        const event = this.events[eventName];
        event &&
            event.fire({
                data: data,
                event: {
                    name: eventName,
                    time: Date.now(),
                },
                target: this,
            });
    }
    on(eventName, callback) {
        let event = this.events[eventName];
        if (!event) {
            event = new DispatcherEvent(eventName);
            this.events[eventName] = event;
        }
        event.registerCallback(callback);
    }
    once(eventName, callback) {
        const onceCallback = (envelope) => {
            callback(envelope);
            this.off(eventName, onceCallback);
        };
        this.on(eventName, onceCallback);
    }
    off(eventName, callback) {
        const event = this.events[eventName];
        if (event && !callback) {
            event.clearCallbacks();
            delete this.events[eventName];
        }
        else if (event && callback && event.callbacks.indexOf(callback) > -1) {
            event.unregisterCallback(callback);
            if (event.callbacks.length === 0) {
                delete this.events[eventName];
            }
        }
    }
    $emit(eventName, data = {}) {
        return this.dispatch(eventName, data);
    }
    trigger(eventName, data = {}) {
        return this.dispatch(eventName, data);
    }
    $on(eventName, callback) {
        return this.on(eventName, callback);
    }
    $off(eventName, callback) {
        return this.off(eventName, callback);
    }
}
export default new Dispatcher();
//# sourceMappingURL=data:application/json;base64,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